import { makeStyles } from '@mui/styles';
import React from 'react'
import { CapaCampos } from './CapaCampos';

export const Decreto = ({formState}) => {
    const classes = useStyles();
    return (
        <div id="decreto" className={classes.contenedor}>
            <img src={`${process.env.PUBLIC_URL}/images/bg-1.png`}/>
            <CapaCampos formState={formState}/>
        </div>
    )
}

const useStyles = makeStyles({
    contenedor:{
        padding:'20px',
        width:'90%',
        maxWidth:' 800px',
        margin:'20px auto',
        position:'relative',
        '& img':{
            width:'100%',
        }
    }
});